// Merch Sherpa Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // Navbar scroll effect
    const navbar = document.getElementById('navbar');
    if (navbar) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
    }

    // Mobile menu toggle
    const menuToggle = document.getElementById('menuToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const menuBackdrop = document.getElementById('menuBackdrop');
    
    function toggleMenu() {
        if (menuToggle && mobileMenu && menuBackdrop) {
            menuToggle.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            menuBackdrop.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        }
    }
    
    if (menuToggle) {
        menuToggle.addEventListener('click', toggleMenu);
    }
    
    if (menuBackdrop) {
        menuBackdrop.addEventListener('click', toggleMenu);
    }
    
    // Close menu when clicking a link
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu a');
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (mobileMenu && mobileMenu.classList.contains('active')) {
                toggleMenu();
            }
        });
    });

    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const target = document.querySelector(targetId);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Product carousel
    const carousel = document.querySelector('.product-showcase-carousel');
    if (carousel) {
        const images = carousel.querySelectorAll('img');
        if (images.length > 0) {
            let currentIndex = 0;
            images[currentIndex].classList.add('active');

            function nextSlide() {
                images[currentIndex].classList.remove('active');
                currentIndex = (currentIndex + 1) % images.length;
                images[currentIndex].classList.add('active');
            }

            setInterval(nextSlide, 5000);
        }
    }

    // Set year in footer
    const yearElement = document.getElementById('year');
    if (yearElement) {
        yearElement.textContent = new Date().getFullYear();
    }

    // Update cart count dynamically (for Shopify)
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                const cartCountElements = document.querySelectorAll('.cart-count');
                cartCountElements.forEach(element => {
                    if (data.item_count > 0) {
                        element.textContent = `(${data.item_count})`;
                    } else {
                        element.textContent = '';
                    }
                });
            })
            .catch(error => console.error('Error fetching cart:', error));
    }

    // Update cart count on page load
    updateCartCount();

    // Listen for cart updates (if using Shopify's Ajax API)
    document.addEventListener('cart:updated', updateCartCount);
});
